// This file is generated by a script and should not be modified directly.
const markdown: string =
  "ROME code(s) for the research scope\n\nThe ROME corresponds to the Operational Reference for Trades and Jobs designed by France Travail.\n\nList of codes separated by commas\n\nThe codes must adhere to the ROME formats\n"
export default markdown
